import { useEffect, useState } from "react";

import TextField from "@mui/material/TextField";

import { request } from "@/Api";
import { store } from "@/sheet/bidStore";

const NoteItem = (props) => {
    const {
        placeholder,
        field,
        onInputChange,
        onInputBlur,
        onInputFocus,
        localBid,
        readOnly,
    } = props;
    return (
        <div style={{ marginBottom: "32px" }}>
            <TextField
                value={localBid[field] || ""}
                placeholder={placeholder}
                fullWidth
                multiline
                minRows={4}
                onBlur={onInputBlur(field)}
                onInput={onInputChange(field)}
                onFocus={onInputFocus(field)}
                disabled={readOnly}
            />
        </div>
    );
};

export default function BidNotes(props) {
    const { bidId, readOnly } = props;
    const [localBid, setLocalBid] = useState({});
    const bid = store.bid;

    const updateBid = (bidPayload) => {
        request.patch(`/bids/${bidId}`, bidPayload);
    };

    const onInputChange = (field) => (event) => {
        // TODO : implement working line handling
        setLocalBid({ ...localBid, [field]: event.target.value });
        setBidFocusData(field, event.target.value);
    };

    const onInputBlur = (field) => (event) => {
        clearBidFocusData();

        var value = event.target.value.trim();
        setLocalBid({ ...localBid, [field]: value });

        if (bid[field] != value) {
            updateBid({ ...localBid, [field]: value });
        }
    };

    const onInputFocus = (field) => (event) => {
        event.preventDefault();
    };

    const setBidFocusData = (field, value) => {
        store.localData.bidFocus.field = field;
        store.localData.bidFocus.value = value;
    };

    const clearBidFocusData = () => {
        setBidFocusData(null, null);
    };

    useEffect(() => {
        if (!bid.id) {
            return;
        }
        let newBid = { ...bid };
        if (store.localData.bidFocus.field) {
            newBid[store.localData.bidFocus.field] =
                store.localData.bidFocus.value;
        }
        setLocalBid(newBid);
    }, [bid]);

    return (
        <div>
            <p>Notes</p>

            <NoteItem
                placeholder="Project Assumptions"
                field="assumptions"
                onInputChange={onInputChange}
                onInputBlur={onInputBlur}
                onInputFocus={onInputFocus}
                localBid={localBid}
                readOnly={readOnly}
            />
            <NoteItem
                placeholder="Bid Includes..."
                field="inclusions"
                onInputChange={onInputChange}
                onInputBlur={onInputBlur}
                onInputFocus={onInputFocus}
                localBid={localBid}
                readOnly={readOnly}
            />
            <NoteItem
                placeholder="Bid does not include..."
                field="exclusions"
                onInputChange={onInputChange}
                onInputBlur={onInputBlur}
                onInputFocus={onInputFocus}
                localBid={localBid}
                readOnly={readOnly}
            />
        </div>
    );
}
